<div class="row">
    <div style="padding-left: 15px;" *ngIf="showSameAsMailingLink">
        <label>{{'BillingAddress.Pharse' |translate}} &nbsp;</label>
        <a (click)="getBillingOrMailingAddress(1)">
            <label style="color: blue;cursor: pointer;"> {{'ProviderSite.MailingAddress'|translate}}</label>
        </a>

    </div>
    <span *ngIf="error" class="error-message">{{error}}</span>
    <form [formGroup]="addressForm">

        <div class="col-md-6">
            <label> {{address1}}<span class="required">*</span>

            </label>


            <input type="text" maxlength="256" formControlName="AddressLine1">

        </div>
        <div class="col-md-6">
            <label> {{address2}}

            </label>


            <input type="text" maxlength="256" formControlName="AddressLine2">

        </div>



        <div class="col-md-6">
            <label>{{city}}<span class="required">*</span>

            </label>


            <input type="text" maxlength="50" formControlName="City">

        </div>
        <div class="col-md-6">
            <label>{{state}}<span class="required">*</span>

            </label>


            <input type="text" maxlength="50" formControlName="State">

        </div>

        <div class="col-md-6">

            <label>{{zipcode}}<span class="required">*</span>

            </label>


            <input type="text" maxlength="9" formControlName="Zipcode">
        </div>
        <div class="col-md-6">
            <label style="display: block;">{{contact}}<span class="required">*</span>

            </label>

            <div class="col-sm-8" style="padding-left: 0px;">
                <input type="text" style="display: block;" mask="000-000-0000" formControlName="Contact"></div>
            <div class="col-sm-2">
                <label style="display:inline-block; padding-top: 15px;">{{ext}}</label> </div>
            <div class="col-sm-2" style="padding-right: 0px;">
                <input maxlength="5" style="
                padding-left: 10px;
                padding-right: 10px;
            " type="text" formControlName="ContactExtension"></div>
        </div>
        <div class="col-md-6" style="clear: both;">
            <label>{{fax}}

            </label>


            <input type="text" mask="000-000-0000" formControlName="Fax">

        </div>
        <div class="col-md-12">

            <button type="submit" (click)="submitForm()" class="btn btn-main"
                [disabled]="!addressForm.valid">{{'Common.Submit'|translate}}</button>
        </div>
    </form>
</div>